<div [ngClass]="cardClass" class="card shadow-sm">
    <div *ngIf="tplHeader || caption" class="card-header p-lg-4 bg-white border-0">
        <ng-template *ngIf="tplHeader; let tpl" [ngTemplateOutlet]="tpl.template"></ng-template>
        <h5 *ngIf="!tplHeader && caption" class="font-weight-normal m-0">{{ caption }}</h5>
    </div>
    <ng-template [ngTemplateOutlet]="tplBody.template"></ng-template>
</div>
